/**
 * ThemeToggle.
 *
 * NOT A FIGMA COMPONENT — and an addition rather than an invention: the
 * "CRF Tokens v3" collection ships a Dark mode with seven re-mapped variables, and
 * a mode nobody can reach is half a design system that never gets tested. The
 * control is built entirely from existing tokens and lucide glyphs; it introduces
 * no colour and no new pattern. Recorded in PHASE2-REPORT as an addition.
 */

import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../../lib/theme';

export function ThemeToggle(): React.JSX.Element {
  const { theme, followsSystem, toggleTheme } = useTheme();
  const next = theme === 'dark' ? 'light' : 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={`Switch to ${next} theme`}
      title={
        followsSystem
          ? `Following your system theme (${theme}). Click for ${next}.`
          : `Switch to ${next} theme`
      }
      className="inline-flex size-9 items-center justify-center rounded-sm text-fg-secondary hover:bg-subtle hover:text-fg"
    >
      {theme === 'dark' ? (
        <Sun aria-hidden="true" className="size-4" />
      ) : (
        <Moon aria-hidden="true" className="size-4" />
      )}
    </button>
  );
}
